// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610211035/js/" + chunkId + "." + {"44":"15080da9","225":"bed4f035","481":"62418634","486":"97dcf1eb","770":"c1947967"}[chunkId] + ".0.466245435153708.chunk.js";
};